var _defs, _path, _path2, _polyline, _polyline2, _polygon, _path3, _polygon2, _polygon3, _polygon4, _polygon5, _line, _polyline3, _polygon6, _polygon7, _polygon8, _polygon9, _g, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 467.85 525",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#979797;}.cls-2{fill:#fff;}.cls-3{fill:#fde480;}.cls-4{isolation:isolate;}.cls-5{fill:none;stroke:#fff;stroke-miterlimit:11.67;}.cls-6{fill:#f7f8f9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m253.64,303.94c0-.22.02-.45.02-.67,0-10.66-10.41-19.31-23.25-19.31s-23.25,8.64-23.25,19.31c0,.23.01.45.02.67h-.07v19.76h46.62v-19.76h-.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m272.29,134.02v95.5h48.4v-95.5h-48.4Zm45.16,35.9s-23.17,5.08-17.01,56.52c0,0-19.2-48.4-4.43-48.66l-19.53.34c5.47-7.4,17.66-14.73,23.08-22.14l-22.2.33-.1-9.82h40.2l-15.46,23.43h15.46Z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "43.49 302.03 43.49 310.04 192.75 310.04 192.75 299.91 43.49 299.91 43.49 302.03"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "116.18 1.72 74.74 189 84.36 189 123.96 10.01 197.51 104.39 209.04 104.39 127.84 0 116.56 0 116.18 1.72"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "336.57 10.24 252.75 115.24 265.21 115.24 340.66 20.71 371.51 200.04 380.53 200.04 347.88 10.24 336.57 10.24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m143.22,111.64v139.98h48.4V111.64h-48.4Zm31.6,98.83h-14.09v-56.46h14.09v56.46Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "30.29 342.66 164.33 316.82 29.55 338.75 29.69 339.53 30.29 342.66"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "194.82 311.86 193.39 312.09 195.27 318.15 30.31 342.73 30.9 345.85 196.17 318.96 194.82 311.86"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "180.05 287.23 29.67 262.76 29.53 263.5 29.15 265.51 180.05 287.23"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "193.97 289.5 192.01 296.19 29.07 265.9 28.32 269.87 193.59 296.76 194.94 289.65 193.97 289.5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 270.08,
    y1: 306.59,
    x2: 270.08,
    y2: 300.7
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "417.22 306.59 417.22 298.58 267.95 298.58 267.95 308.71 417.22 308.71 417.22 306.59"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "430.41 265.95 296.38 291.8 431.16 269.87 431.01 269.09 430.41 265.95"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "265.89 296.76 267.31 296.53 265.43 290.47 430.4 265.89 429.8 262.76 264.53 289.65 265.89 296.76"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "280.66 321.39 431.03 345.85 431.17 345.12 431.56 343.11 280.66 321.39"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "266.74 319.12 268.7 312.43 431.63 342.72 432.39 338.75 267.12 311.86 265.76 318.96 266.74 319.12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "text1-2-3",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m8.41,442.8c0,1.81-.11,7.29,6.97,7.29,4.47,0,7.29-2.13,7.29-5.38,0-3.41-2.39-3.99-7.29-5.16-9.16-2.29-14.16-5.01-14.16-11.66s4.52-11.93,15.23-11.93c3.99,0,8.73.91,11.61,4.53,2.18,2.77,2.18,5.85,2.18,7.13h-7.93c-.11-1.33-.53-5.86-6.23-5.86-3.83,0-6.34,2.08-6.34,5.22,0,3.57,2.82,4.21,8.36,5.59,6.65,1.6,13.2,3.41,13.2,10.91,0,6.92-5.75,12.51-16.4,12.51-14.75,0-14.85-9.48-14.91-13.2h8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.78,423h-11.45v-6.39h31.2v6.39h-11.45v32.1h-8.3v-32.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m84.01,416.61l13.36,38.49h-8.31l-2.77-8.31h-15.23l-2.87,8.31h-7.88l13.89-38.49h9.8Zm.21,23.96l-5.32-16.4-5.7,16.4h11.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m102.33,416.61h11.93l14.43,30.29v-30.29h7.67v38.49h-11.34l-14.91-31.94v31.94h-7.77v-38.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m143.38,416.71l12.73.05c2.13,0,8.62.05,13.25,3.46,4.84,3.57,6.55,9.64,6.55,15.12,0,11.82-6.34,18-13.63,19.33-1.44.27-3.03.43-6.92.43h-11.98v-38.38Zm8.36,32.05c.91.05,2.29.11,3.25.11,3.51,0,6.55-.27,8.94-2.66,3.25-3.25,3.46-9,3.46-10.86,0-5.43-1.86-10.43-7.03-11.87-1.7-.48-3.89-.75-8.62-.53v25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m200.19,416.61l13.36,38.49h-8.31l-2.77-8.31h-15.23l-2.87,8.31h-7.88l13.89-38.49h9.8Zm.21,23.96l-5.32-16.4-5.7,16.4h11.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m217.87,416.61h14.75c4.26-.05,8.57-.05,11.66,2.61,2.4,2.08,3.35,4.9,3.35,7.4,0,7.19-6.18,8.89-8.04,9.42,5.8.53,6.23,3.83,6.92,8.84.58,4.52.9,6.39,1.17,7.45.43,1.7.75,2.13,1.17,2.77h-9.1c-.37-2.13-1.54-11.87-2.08-13.36-.75-2.18-2.77-2.18-4.15-2.18h-7.24v15.54h-8.41v-38.49Zm8.14,16.82h6.65c.96,0,2.88,0,4.21-1.06.59-.43,2.13-1.76,2.13-4.47s-1.28-3.83-2.02-4.31c-1.28-.9-2.82-.9-5.43-.9h-5.54v10.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m253.64,416.71l12.72.05c2.13,0,8.62.05,13.26,3.46,4.84,3.57,6.55,9.64,6.55,15.12,0,11.82-6.34,18-13.63,19.33-1.44.27-3.03.43-6.92.43h-11.98v-38.38Zm8.36,32.05c.91.05,2.29.11,3.25.11,3.51,0,6.55-.27,8.94-2.66,3.25-3.25,3.46-9,3.46-10.86,0-5.43-1.86-10.43-7.03-11.87-1.7-.48-3.89-.75-8.62-.53v25.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m306.62,416.5h8.25v38.6h-8.25v-38.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m328.5,442.8c0,1.81-.11,7.29,6.97,7.29,4.47,0,7.29-2.13,7.29-5.38,0-3.41-2.39-3.99-7.29-5.16-9.16-2.29-14.16-5.01-14.16-11.66s4.52-11.93,15.23-11.93c3.99,0,8.73.91,11.61,4.53,2.18,2.77,2.18,5.85,2.18,7.13h-7.93c-.11-1.33-.53-5.86-6.23-5.86-3.83,0-6.34,2.08-6.34,5.22,0,3.57,2.82,4.21,8.36,5.59,6.65,1.6,13.2,3.41,13.2,10.91,0,6.92-5.75,12.51-16.4,12.51-14.75,0-14.85-9.48-14.91-13.2h8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m364.01,442.8c0,1.81-.11,7.29,6.97,7.29,4.47,0,7.29-2.13,7.29-5.38,0-3.41-2.39-3.99-7.29-5.16-9.16-2.29-14.16-5.01-14.16-11.66s4.52-11.93,15.23-11.93c3.99,0,8.73.91,11.61,4.53,2.18,2.77,2.18,5.85,2.18,7.13h-7.93c-.11-1.33-.53-5.86-6.23-5.86-3.83,0-6.34,2.08-6.34,5.22,0,3.57,2.82,4.21,8.36,5.59,6.65,1.6,13.2,3.41,13.2,10.91,0,6.92-5.75,12.51-16.4,12.51-14.75,0-14.85-9.48-14.91-13.2h8.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m401.33,416.71v23.42c0,4.21.32,9.48,8.36,9.48,1.33,0,5.32-.05,7.45-3.35.8-1.17,1.22-2.66,1.22-6.55v-23h8.04v24.01c0,11.45-9.1,15.12-16.88,15.12-3.83,0-10.86-.85-14.48-6.65-1.86-2.93-1.97-5.91-1.97-9.48v-23h8.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m434.61,416.61h25.77v6.28h-17.51v9.16h16.4v6.28h-16.4v10.38h18.1v6.39h-26.35v-38.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m44.5,512.01h-25.02c.53,5.48,4.05,9.37,9.9,9.37,3.78,0,7.77-1.6,8.94-5.43h5.54c-1.06,7.14-8.31,9.05-14.21,9.05-9.8,0-15.38-5.38-15.38-13.84,0-9.74,5.86-14.91,15.54-14.91s14.69,5.11,14.69,14.16v1.6Zm-5.54-3.62c-.11-6.18-4.68-8.52-9.26-8.52-5.38,0-9.21,2.61-10.01,8.52h19.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m83.42,485.55h5.22v38.44h-5.22v-38.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m157.8,512.01h-25.02c.53,5.48,4.05,9.37,9.9,9.37,3.78,0,7.77-1.6,8.94-5.43h5.54c-1.06,7.14-8.31,9.05-14.21,9.05-9.8,0-15.38-5.38-15.38-13.84,0-9.74,5.86-14.91,15.54-14.91s14.69,5.11,14.69,14.16v1.6Zm-5.54-3.62c-.11-6.18-4.68-8.52-9.26-8.52-5.38,0-9.21,2.61-10.01,8.52h19.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m223.92,515.36c-.53,6.76-7.45,9.64-14.27,9.64-9.96,0-15.23-5.7-15.23-14.32s6.07-14.43,15.71-14.43c6.44,0,12.67,2.55,13.57,9.53h-5.54c-.48-3.89-3.62-5.91-7.99-5.91-5.64,0-10.22,3.67-10.22,10.81,0,5.7,3.35,10.7,9.95,10.7,4.9,0,8.2-2.29,8.47-6.02h5.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m266.46,492.37l5.22-2.18v7.08h7.88v3.62h-7.88v15.38c0,2.88.8,4.42,4.05,4.42.96,0,2.5-.11,3.99-.32v3.62c-1.7.21-3.41.32-5.01.32-5.27,0-8.25-1.7-8.25-7.67v-15.76h-6.97v-3.62h6.97v-4.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m317.52,503.33c0-2.02-.11-3.94-.21-6.07h4.9c.11,1.6.21,3.51.21,5.32h.11c2.39-4.31,4.74-5.7,10.7-5.7h1.76v4.68c-.8-.26-1.54-.32-2.5-.32-6.28,0-9.74,4.42-9.74,9.8v12.94h-5.22v-20.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m372.57,485.55h5.22v5.32h-5.22v-5.32Zm0,11.71h5.22v26.73h-5.22v-26.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m446.58,515.36c-.53,6.76-7.45,9.64-14.27,9.64-9.96,0-15.23-5.7-15.23-14.32s6.07-14.43,15.71-14.43c6.44,0,12.67,2.55,13.57,9.53h-5.54c-.48-3.89-3.62-5.91-7.99-5.91-5.64,0-10.22,3.67-10.22,10.81,0,5.7,3.35,10.7,9.95,10.7,4.9,0,8.2-2.29,8.47-6.02h5.54Z"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path3-8-0",
    className: "cls-5",
    d: "m.73,473.13h467.12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.459a8fbcc434292ba55d7e668c0f4f93.svg";
export { ForwardRef as ReactComponent };